/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalEntityDetails } from './';
import {
    LegalEntityDetailsFromJSON,
    LegalEntityDetailsFromJSONTyped,
    LegalEntityDetailsToJSON,
} from './';
import type { SalesManager } from './';
import {
    SalesManagerFromJSON,
    SalesManagerFromJSONTyped,
    SalesManagerToJSON,
} from './';
import type { TeamLogo } from './';
import {
    TeamLogoFromJSON,
    TeamLogoFromJSONTyped,
    TeamLogoToJSON,
} from './';
import type { TeamMember } from './';
import {
    TeamMemberFromJSON,
    TeamMemberFromJSONTyped,
    TeamMemberToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationTeamDetailsResource
 */
export interface OrganizationTeamDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof OrganizationTeamDetailsResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTeamDetailsResource
     */
    name: string;
    /**
     * 
     * @type {TeamLogo}
     * @memberof OrganizationTeamDetailsResource
     */
    logo?: TeamLogo;
    /**
     * 
     * @type {SalesManager}
     * @memberof OrganizationTeamDetailsResource
     */
    salesManager?: SalesManager;
    /**
     * 
     * @type {Array<LegalEntityDetails>}
     * @memberof OrganizationTeamDetailsResource
     */
    legalEntities: Array<LegalEntityDetails>;
    /**
     * 
     * @type {Array<TeamMember>}
     * @memberof OrganizationTeamDetailsResource
     */
    teamAdmins: Array<TeamMember>;
    /**
     * 
     * @type {number}
     * @memberof OrganizationTeamDetailsResource
     */
    membersCount: number;
}

/**
 * Check if a given object implements the OrganizationTeamDetailsResource interface.
 */
export function instanceOfOrganizationTeamDetailsResource(value: object): value is OrganizationTeamDetailsResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('legalEntities' in value) || value['legalEntities'] === undefined) return false;
    if (!('teamAdmins' in value) || value['teamAdmins'] === undefined) return false;
    if (!('membersCount' in value) || value['membersCount'] === undefined) return false;
    return true;
}

export function OrganizationTeamDetailsResourceFromJSON(json: any): OrganizationTeamDetailsResource {
    return OrganizationTeamDetailsResourceFromJSONTyped(json, false);
}

export function OrganizationTeamDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationTeamDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'logo': json['logo'] == null ? undefined : TeamLogoFromJSON(json['logo']),
        'salesManager': json['salesManager'] == null ? undefined : SalesManagerFromJSON(json['salesManager']),
        'legalEntities': ((json['legalEntities'] as Array<any>).map(LegalEntityDetailsFromJSON)),
        'teamAdmins': ((json['teamAdmins'] as Array<any>).map(TeamMemberFromJSON)),
        'membersCount': json['membersCount'],
    };
}

export function OrganizationTeamDetailsResourceToJSON(value?: OrganizationTeamDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'logo': TeamLogoToJSON(value['logo']),
        'salesManager': SalesManagerToJSON(value['salesManager']),
        'legalEntities': ((value['legalEntities'] as Array<any>).map((v) => LegalEntityDetailsToJSON(v))),
        'teamAdmins': ((value['teamAdmins'] as Array<any>).map((v) => TeamMemberToJSON(v))),
        'membersCount': value['membersCount'],
    };
}

